import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import authReducer from "./features/auth/authSlice";
import loginPageReducer from "./pages/auth/login/login.slice";
import companySelectReducer from "./features/company-select/company-select.slice";
import companyCreateReducer from "./features/company-create/company-create.slice";
import modalxReducer from "components/modalx/modalx.slice";
import tasksReducer from "./features/tasks/tasks.slice";
import usersReducer from "./features/users/users.slice";
import userFormReducer from "./features/user-form/user-form.slice";
import customersReducer from "./features/customers/customers.slice";
import customerFormReducer from "./features/customer-form/customer-form.slice";
import ordersReducer from "features/orders/orders.slice";
import vatsReducer from "./features/vats/vats.slice";
import vatFormReducer from "./features/vat-form/vat-form.slice";
import productsReducer from "./features/products/products.slice";
import productFormReducer from "./features/product-form/product-form.slice";
import productGroupsReducer from "./features/product-groups/product-groups.slice";
import customerReducer from "./containers/customer/customer-container.slice";
import debtInvoicesReducer from "./containers/debt-invoices/debt-invoices-container.slice";
import fileFormReducer from "./containers/file-form/file-form.slice";
import filesCategoriesReducer from "./containers/files-categories/files-categories-container.slice";
import filesTemplatesReducer from "./containers/files-templates/files-templates-container.slice";
import reservationsReducer from "containers/reservations/reservations.slice";
import projectBoardsReducer from "containers/project-boards/project-boards.slice";
import projectBoardReducer from "containers/project-board/project-board-container.slice";
import projectReducer from "containers/project-view-container/project-container.slice";
import documentCategoryReducer from "containers/document/category-tree/category-tree.Slice";
import documentFilesReducer from "containers/document/category-files/catFiles.Slice";
import fileContainerReducer from "containers/file/file.Slice";
import authorizedFileContainerReducer from "containers/file-authorized/authorized-file.Slice";
import userContainerReducer from "containers/user/user-container.slice";
import customFieldReducer from "containers/custom-field/custom-field-container.slice";
import seriesReducer from "containers/files-series/files-series-container.slice";
import invoiceSeriesReducer from "containers/invoice-series/invoice-series-container.slice";
import companyContainerReducer from "containers/settings/settings-container.slice";
import filesTypesReducer from "containers/files-types/files-types-container.slice";
import departmentsReducer from "containers/departments/departments-container.slice";
import documentCategoryPermissionReducer from "containers/document/category-permissions-tree/category-tree-permission.Slice";
import customerAccessReducer from "containers/customers-access-list/customers.slice";
import customerHideReducer from "containers/customers-hide-list/customers.slice";
import addressListCollectionReducer from "features/customer-address-select-multiple/customer-address-select-multiple.slice";
import assetsReducer from "containers/assets/assets.slice";
import assetContainerReducer from "containers/asset-view-container/asset-container.slice";
import assetsTypesReducer from "containers/assets-types/assets-types-container.slice";
import customerOrdersReducer from "features/customers-orders/customer-orders.slice";
import orderContainerReducer from "containers/order-view-container/order-container.slice";
import userAssetsReducer from "containers/user-assets/user-assets.slice";
import fuelReportReducer from "containers/fuel-reports/fuel-reports.slice";
import userAssetsFuelReportReducer from "containers/user-assets-fuel-reports/fuel-reports.slice";
import fuelReportContainerReducer from "containers/fuel-report-view-container/fuel-report-container.slice";
import businessTripsReducer from "containers/business-trips/business-trips.slice";
import userBusinessTripsReducer from "containers/user-business-trips/user-business-trips.slice";
import businessTripContainerReducer from "containers/business-trip-view-container/business-trip-container.slice";
import signontabUserContainerReducer from "containers/signontab-users/signontab-users-container.slice";
import unsignedFilesReducer from "containers/unsigned-files/unsigned-files.slice";
import deliveriesReducer from "features/deliveries/deliveries.slice";
import orderReservationsReducer from "features/reservations/reservations.slice";
import financeDetailReducer from "./containers/finance-detail/finance-detail-container.slice";
import leaveCalendarReducer from "features/leave-calendar/leaveCalendarSlice";
import onboardingsReducer from "containers/onboardings/onboardings.slice";
import onboardingContainerReducer from "containers/onboarding-view-container/onboarding-container.slice";
import jobLeavesReducer from "containers/job-leaves/job-leaves.slice";
import jobLeaveViewReducer from "containers/job-leave-view-container/job-leave-view.slice";
import mergeHistoryContainerReducer from "containers/user-merge-history/user-merge-history-container.slice";
import presenceReducer from "features/presence/presence.slice";
import chatReducer from "features/chat/chat.slice";
import assistantReducer from "features/assistant/assistant.slice";
import recognitionReducer from "features/recognition/recognition.slice";
import documentCartReducer from "features/document-cart/documentCart.slice";
import invoiceApprovalsReducer from "features/invoice-approvals/invoice-approvals.slice";
import wsApprovalsReducer from "features/work-security-approvals/work-security-approvals.slice";
import probationReviewsReducer from "features/probation-reviews/probation-reviews.slice";
import cabinetSummaryReducer from "features/cabinet-tasks/cabinet-summary.slice";

const reducer = combineReducers({
  authReducer,
  loginPageReducer,
  companySelectReducer,
  companyCreateReducer,
  modalxReducer,
  tasksReducer,
  usersReducer,
  userFormReducer,
  customersReducer,
  customerFormReducer,
  ordersReducer,
  vatsReducer,
  vatFormReducer,
  productsReducer,
  productFormReducer,
  productGroupsReducer,
  customerReducer,
  debtInvoicesReducer,
  fileFormReducer,
  filesCategoriesReducer,
  filesTemplatesReducer,
  reservationsReducer,
  projectBoardsReducer,
  projectBoardReducer,
  projectReducer,
  documentCategoryReducer,
  documentFilesReducer,
  fileContainerReducer,
  userContainerReducer,
  customFieldReducer,
  seriesReducer,
  invoiceSeriesReducer,
  companyContainerReducer,
  filesTypesReducer,
  departmentsReducer,
  documentCategoryPermissionReducer,
  customerAccessReducer,
  customerHideReducer,
  addressListCollectionReducer,
  authorizedFileContainerReducer,
  assetsReducer,
  assetContainerReducer,
  assetsTypesReducer,
  customerOrdersReducer,
  orderContainerReducer,
  userAssetsReducer,
  fuelReportReducer,
  userAssetsFuelReportReducer,
  fuelReportContainerReducer,
  businessTripsReducer,
  userBusinessTripsReducer,
  businessTripContainerReducer,
  signontabUserContainerReducer,
  unsignedFilesReducer,
  deliveriesReducer,
  orderReservationsReducer,
  financeDetailReducer,
  leaveCalendar: leaveCalendarReducer,
  onboardingsReducer,
  onboardingContainerReducer,
  jobLeavesReducer,
  jobLeaveViewReducer,
  mergeHistoryContainerReducer,
  presenceReducer,
  chatReducer,
  assistantReducer,
  recognitionReducer,
  documentCartReducer,
  invoiceApprovalsReducer,
  wsApprovalsReducer,
  probationReviewsReducer,
  cabinetSummaryReducer,
});

const store = configureStore({ reducer });

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
